import { render, staticRenderFns } from "./PromoRelatedSubvendorSelect.vue?vue&type=template&id=69cf58e8&"
import script from "./PromoRelatedSubvendorSelect.vue?vue&type=script&lang=js&"
export * from "./PromoRelatedSubvendorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VChip,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src80380595/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69cf58e8')) {
      api.createRecord('69cf58e8', component.options)
    } else {
      api.reload('69cf58e8', component.options)
    }
    module.hot.accept("./PromoRelatedSubvendorSelect.vue?vue&type=template&id=69cf58e8&", function () {
      api.rerender('69cf58e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PromoRelatedSubvendorSelect.vue"
export default component.exports